// External Libraries
import Container from '@material-ui/core/Container'
import React, { useEffect, useRef, useState } from 'react'

// Styles
import * as styles from '../partnerListings'

// Components
import Breadcrumbs from '../../../global/breadcrumbs'
import GoTop from '../../../global/goTop'
import Pagination from '../../../global/pagination'
import SEOTags from '../../../global/seoTags'
import Typography from '../../../global/typography'
import Layout from '../../../layouts/layout'
import PartnersModal from '../partnersModal'

//Images
import arrowLongRight from '../../../../../static/steam-img/arrows/24x24_ArrowLong_Right.svg'
import btnPrimaryIcon from '../../../../../static/steam-img/arrows/button-primary-arrow-icon.svg'
import partnerBlank from '../../../../../static/steam-img/partners-image-blank.png'

// Helpers
import { getPartnersTabMicrocopies } from '../../../../utils/partners.utils'
import UrlUtil from '../../../../utils/url.utils'

// Constants
import { ModuleNames } from '../../../../constants/componentNames.constants'
import ImgUtil from '../../../../utils/img.utils'
import WrapperImage from '../../../global/wrapperImage'

const TechnologyPartners = ({
  pageContext: { technologyPartners, technologyPartnersCategories, pageData },
  path,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  const locationData = path ? path : '/'
  const pageName =
    pageData && pageData.contentfulPageFlex && pageData.contentfulPageFlex.name
      ? pageData.contentfulPageFlex.name
      : 'Technology Partners'

  const partnersListingNameTypes =
    pageData &&
    pageData.contentfulPageFlex &&
    pageData.contentfulPageFlex.modules &&
    pageData.contentfulPageFlex.modules.length >= 2 &&
    pageData.contentfulPageFlex.modules[1].key == 'Partners Listing'
      ? pageData.contentfulPageFlex.modules[1].values
      : []

  const {
    businessPartnersTabText,
    businessPartnersTabUrl,
    publicSectorPartnersTabText,
    publicSectorPartnersTabUrl,
    technologyPartnersTabText,
    technologyPartnersTabUrl,
  } = getPartnersTabMicrocopies(partnersListingNameTypes)
  const [technologyPartnersData, setTechnologyPartnerData] = useState([])

  // tempRendering
  const [toggleReRender, setToggleReRender] = useState(false)

  // Search
  const [showSearch, setShowSearch] = useState(false)
  const [searchText, setSearchText] = useState('')
  const searchInputRef = useRef<HTMLInputElement>()

  // Filters
  const [isCategoryFilterActive, setIsCategoryFilterActive] = useState(false)
  const [categoryFilter, setCategoryFilter] = useState('')

  // Pagination

  const docsPerPage = 12

  // Popup box
  const [open, setOpen] = useState(false) //modal
  const [selectedPartner, setSelectedPartner] = useState() //modal data
  const pagePath = '/partners/technology-alliances'

  const handleShowSearch = (e: any) => {
    setShowSearch(true)
  }

  const handleCloseSearch = (e: any) => {
    setSearchText('')
    setShowSearch(false)
    if (searchText) {
      handlePaginationClick(1)
      history.pushState(null, null, UrlUtil.removeURLParameter(window.location.href, 'search'))
    }
  }

  const handleSearchInput = (e: any) => {
    setSearchText(e.target.value)
    handlePaginationClick(1)
    history.pushState(
      null,
      null,
      UrlUtil.updateURLParameter(
        window.location.href,
        'search',
        e.target.value.toLowerCase().split('/').join('_').replace(/ /g, '-')
      )
    )
  }

  const handleFilterClick = (e: any) => {
    e.preventDefault()
    if (e.target.id === 'category' || e.target.parentElement.id === 'category') {
      setIsCategoryFilterActive(!isCategoryFilterActive)
    }
  }

  const handleFilterItemClick = (e: any) => {
    e.preventDefault()

    if (e.target.getAttribute('data-item') === 'category') {
      history.pushState(
        null,
        null,
        UrlUtil.updateURLParameter(
          window.location.href,
          'category',
          e.target.textContent.toLowerCase().split('/').join('_').replace(/ /g, '-')
        )
      )
      if (e.target.textContent.toLowerCase() === 'show all') {
        setCategoryFilter('')
        history.pushState(
          null,
          null,
          UrlUtil.updateURLParameter(window.location.href, 'category', 'all')
        )
      } else {
        setCategoryFilter(e.target.textContent)
      }
      setIsCategoryFilterActive(false)
    }

    handlePaginationClick(1)
  }

  const handleResetFilters = () => {
    setCategoryFilter('')
    history.pushState(null, null, UrlUtil.removeURLParameter(window.location.href, 'category'))
    handlePaginationClick(1)
  }

  const hrefForPage = (page: number) => {
    let url = ''

    if (page === 1) {
      // url = /partners/business-partners
      if (typeof window !== 'undefined') {
        url = `${pagePath}${window.location.search}`
      } else if (pageData && pageData.path) {
        url = `${pagePath}`
      }
    } else {
      // url = /partners/business-partners/page?[query]
      if (typeof window !== 'undefined') {
        url = `${pagePath}/${page}${window.location.search}`
      } else {
        url = `${pagePath}/${page}`
      }
    }
    return url
  }
  //only control the current page in one location NO STATE
  const getPageNumber = () => {
    if (typeof window !== 'undefined') {
      let page = UrlUtil.getPageNumberForPagniation(window.location.pathname)
      if (page && page != '') {
        return parseInt(page)
      }
    } else {
      if (pageData && pageData.path) {
        let page = UrlUtil.getPageNumberForPagniation(pageData.path)
        if (page) {
          return parseInt(page)
        }
      }
    }
    return 1
  }

  //only used internally not by the paging system
  const handlePaginationClick = (page: number) => {
    let urlQuery = typeof window !== 'undefined' ? window.location.search : ''

    if (page > 1) {
      history.pushState(null, null, `${pagePath}/${page}${urlQuery}`)
    } else {
      history.pushState(null, null, `${pagePath}${urlQuery}`)
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleClose = () => {
    setOpen(false)
  }

  const openModal = (partner: any) => {
    setSelectedPartner(partner)
    setOpen(true)
  }

  const handleTileClick = (event: any, partner: any) => {
    event.preventDefault()
    openModal(partner)
  }

  const init = () => {
    setTechnologyPartnerData(technologyPartners)
    if (UrlUtil.getUrlParameter('category') || UrlUtil.getUrlParameter('page')) {
      setCategoryFilter(
        UrlUtil.getUrlParameter('category') !== 'all'
          ? UrlUtil.getUrlParameter('category').replace(/_/g, '/').replace(/-/g, ' ')
          : ''
      )
    }
    if (UrlUtil.getUrlParameter('search')) {
      // If there's a search, populate the search bar with existing data
      setSearchText(
        UrlUtil.getUrlParameter('search') !== ''
          ? UrlUtil.getUrlParameter('search').replace(/-/g, ' ')
          : ''
      )
      setShowSearch(true)
    }
    setToggleReRender(true)
  }

  const filterPartners = () => {
    //this means we haven't run init yet (like when doing the html rendering during createPage rendering)
    if (!technologyPartnersData || technologyPartnersData.length == 0) {
      setCategoryFilter('')
      setSearchText('')
      setTechnologyPartnerData(technologyPartners)
    }

    let partnerData = technologyPartnersData
      .filter((partner: any) => {
        const partnerLogo = partner['Partner_Locator_Logo__c']
        const partnerName = partner['Partner_Locator_Account_Name__c']
        const partnerDescription = partner['Partner_Locator_Account_Description__c']
        const partnerLink = partner['Partner_Locator_Website__c']
        // Partner must have a name or logo and a description or link to be displayed
        if ((partnerName || partnerLogo) && (partnerDescription || partnerLink)) {
          return true
        }
      })
      .filter((partner: any) => {
        if (!categoryFilter) {
          return true
        } else if (
          partner['Technology_Partner_Category__c'].toLowerCase() === categoryFilter.toLowerCase()
        ) {
          return true
        }
      })
      .filter((partner: any) => {
        if (!searchText) {
          return true
        } else if (
          (partner['BillingCountry'] &&
            partner['BillingCountry'].toLowerCase().includes(searchText.toLowerCase())) ||
          (partner['Partner_Locator_Account_Name__c'] &&
            partner['Partner_Locator_Account_Name__c']
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (partner['Partner_Locator_Account_Description__c'] &&
            partner['Partner_Locator_Account_Description__c']
              .toLowerCase()
              .includes(searchText.toLowerCase()))
        ) {
          return true
        }
      })
    return partnerData
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (searchInputRef && searchInputRef.current) searchInputRef.current.focus()
  }, [showSearch])

  const generateDynamicHero = () => {
    let headline, subheadline
    if (pageData.contentfulPageFlex && pageData.contentfulPageFlex.modules) {
      for (let i = 0; i < pageData.contentfulPageFlex.modules.length; i++) {
        if (
          pageData.contentfulPageFlex.modules[i].__typename &&
          pageData.contentfulPageFlex.modules[i].__typename === ModuleNames.HERO
        ) {
          const hero = pageData.contentfulPageFlex.modules[i]
          if (hero.headline) {
            headline = hero.headline
          }
          if (hero.subheadline && hero.subheadline.subheadline) {
            subheadline = hero.subheadline.subheadline
          }
        }
      }
    }
    return [headline, subheadline]
  }

  const seoData =
    pageData && pageData.contentfulPageFlex && pageData.contentfulPageFlex.seoMetadata
      ? pageData.contentfulPageFlex.seoMetadata
      : null

  const dynamicHeroData = generateDynamicHero()
  const currentPage = getPageNumber()
  const start = (currentPage - 1) * docsPerPage
  const end = currentPage * docsPerPage

  const becomeAPartnerObj =
    partnersListingNameTypes?.filter((listing: any) => {
      const partnerText = 'Partners.application.CTA.text'
      const partnerUrl = 'Partners.application.CTA.url'
      return listing.key === partnerText || listing.key === partnerUrl
    }) || []

  //what this is doing is ignoring all server side rendering (because that's what we're tying to fix) we will remove this once we get the initial html gen to work
  // if (!toggleReRender) {
  //   return <div></div>
  // }
  return (
    <Layout.Template
      lang="en-US"
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      slug={pageData.contentfulPageFlex.slug}>
      <div data-cy="TechnologyPartnerPage">
        <SEOTags
          seoMetadata={seoData}
          slug={pageData.contentfulPageFlex.slug}
          path={path}
          isPaginated={true}
          pageNum={currentPage}
          hrefForPage={hrefForPage}
          isLastPage={currentPage === Math.ceil(filterPartners().length / docsPerPage)}
        />
        <styles.Wrapper>
          <styles.Grid></styles.Grid>
          <Container>
            <Breadcrumbs theme="light" currentPathname={locationData} pageName={pageName} />
            <styles.PartnersHeader>
              <h1>{dynamicHeroData[0]}</h1>
              <p>{dynamicHeroData[1]}</p>
            </styles.PartnersHeader>
          </Container>

          <Container className="PartnersLocator__searchWrapper">
            {/* Search Partners */}
            <styles.PartnersSearch>
              <div className="PartnersLocator__searchContainer">
                <div className="PartnersLocator__search">
                  <i
                    className={`fa fa-search ${showSearch ? 'active' : ''}`}
                    onClick={handleShowSearch}></i>
                  <input
                    type="text"
                    placeholder="Search"
                    className={showSearch ? 'expanded' : ''}
                    value={searchText}
                    onChange={handleSearchInput}
                    ref={searchInputRef}
                  />
                  <i
                    className={`fa fa-times close ${showSearch ? 'active' : ''}`}
                    onClick={handleCloseSearch}></i>
                </div>
              </div>
              <div className="PartnersLocator__typesContainer">
                <ul className="PartnersLocator__types">
                  <li>
                    <a href={businessPartnersTabUrl}>{businessPartnersTabText}</a>
                  </li>
                  <li>
                    <a href={publicSectorPartnersTabUrl}>{publicSectorPartnersTabText}</a>
                  </li>
                  <li className="selected">
                    <a href={technologyPartnersTabUrl}>{technologyPartnersTabText}</a>
                  </li>
                </ul>
              </div>
            </styles.PartnersSearch>
          </Container>
          <Container>
            <div className="PartnersLocator__wrapper">
              {/* Partners List */}
              <div className="PartnersLocator__itemsContainer">
                <styles.gridWrapper>
                  {filterPartners()
                    .slice(start, end)
                    .map((partner: any) => {
                      let partnerLink = partner['Partner_Locator_Website__c']
                        ? partner['Partner_Locator_Website__c']
                        : ''
                      //bad urls coming from DB
                      if (partnerLink.includes('http:') && !partnerLink.includes('https:')) {
                        partnerLink.replace('http:', 'https:')
                      }

                      const partnerDescription = partner['Partner_Locator_Account_Description__c']
                        ? partner['Partner_Locator_Account_Description__c']
                        : ''
                      const partnerName = partner['Partner_Locator_Account_Name__c']
                        ? partner['Partner_Locator_Account_Name__c']
                        : ''

                      const truncatedDesc =
                        partnerDescription.length < 70
                          ? partnerDescription
                          : partnerDescription.substring(0, 70) + '...'

                      const isFeatured = partner['Strategic_Technology_Alliance_Partner__c']

                      // Not featured partner that has a Business Name, Business Description, Business Link Href needed for Modal
                      const hasModalInfo =
                        !isFeatured && partnerName && partnerDescription && partnerLink

                      const isInternalPage = partnerLink && partnerLink.includes('www.uipath.com')

                      const tileInner = (
                        <React.Fragment>
                          <styles.itemTags>
                            {isFeatured && (
                              <styles.headerTags level="Featured">
                                <Typography type="microAlt">Featured</Typography>
                              </styles.headerTags>
                            )}
                          </styles.itemTags>
                          <styles.PartnerLogoContainer>
                            <styles.partnerLogo
                              src={
                                partner['Partner_Locator_Logo__c']
                                  ? ImgUtil.getResizedImageUrl(
                                      partner['Partner_Locator_Logo__c'],
                                      ''
                                    )
                                  : '/steam-img/partners-image-blank.png'
                              }
                              alt={`${partnerName} logo`}
                            />
                          </styles.PartnerLogoContainer>

                          <styles.PartnerInfo>
                            <styles.partnerInfoCountry>
                              {partner['Technology_Partner_Category__c'] === null
                                ? ''
                                : partner['Technology_Partner_Category__c']}
                            </styles.partnerInfoCountry>
                            <h4 className="Partner-Info__Name">{partnerName}</h4>
                            <div
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: truncatedDesc,
                              }}></div>
                          </styles.PartnerInfo>
                        </React.Fragment>
                      )

                      if (hasModalInfo) {
                        return (
                          <styles.gridBox
                            key={partner._id}
                            onClick={e => handleTileClick(e, partner)}
                            rel="noopener noreferrer"
                            href="#">
                            {tileInner}
                          </styles.gridBox>
                        )
                      } else {
                        return (
                          <styles.gridBox
                            key={partner._id}
                            href={partnerLink}
                            target={isInternalPage ? '_self' : '_blank'}
                            rel="noopener noreferrer nofollow">
                            {tileInner}
                          </styles.gridBox>
                        )
                      }
                    })}

                  {/* Search no results */}
                  {filterPartners().length === 0 && (
                    <div
                      className={`SearchListing__searchNoResults SearchListing__searchNoResults--active`}>
                      <h2>No results</h2>
                      <p>
                        Your keywords or filter selection produced no results. Maybe you can try to:
                      </p>
                      <ul className="SearchListing__searchNoResults__list">
                        <li className="SearchListing__searchNoResults__listItem">
                          <p>Broaden your search criteria</p>
                        </li>

                        <li className="SearchListing__searchNoResults__listItem">
                          <p>Use different filters</p>
                        </li>
                      </ul>
                    </div>
                  )}
                </styles.gridWrapper>
                <styles.PaginationContainer>
                  {filterPartners().length > docsPerPage && (
                    <Pagination
                      activePage={currentPage}
                      hrefForPage={hrefForPage}
                      handleClick={handlePaginationClick}
                      numResults={filterPartners().length}
                      numPagesBeforeEllipses={3}
                      numResultsPerPage={docsPerPage}
                    />
                  )}
                </styles.PaginationContainer>
              </div>

              <styles.PartnersLocatorFilters>
                <div className="PartnersLocator__filtersContainer">
                  <div className="PartnersLocator__filter">
                    <span className="PartnersLocator__filterTitle">Category</span>
                    <div
                      id="category"
                      className={`PartnersLocator__filterClosed ${
                        isCategoryFilterActive ? 'is-active' : ''
                      }`}
                      onClick={handleFilterClick}>
                      <span>{categoryFilter ? categoryFilter : 'Show All'}</span>
                    </div>
                    <div
                      className={`PartnersLocator__filterOpened ${
                        isCategoryFilterActive ? 'is-active' : ''
                      }`}>
                      <ul>
                        <li key="show_all" data-item="category" onClick={handleFilterItemClick}>
                          Show all
                        </li>
                        {technologyPartnersCategories &&
                          technologyPartnersCategories
                            .filter((item: any) => (item ? true : false))
                            .sort((a: any, b: any) => {
                              if (a < b) {
                                return -1
                              }
                            })
                            .map((category: any, index: any) => (
                              <li
                                key={`category_${index}`}
                                data-item="category"
                                onClick={handleFilterItemClick}>
                                {category}
                              </li>
                            ))}
                      </ul>
                    </div>
                  </div>

                  {/* Reset filters */}
                  <div className="PartnersLocator__filter">
                    <span
                      id="resetFilters"
                      className={`PartnersLocator__resetFilters ${
                        categoryFilter ? 'PartnersLocator__resetFilters--active' : ''
                      }`}
                      onClick={handleResetFilters}>
                      Reset filters <i className="fa fa-times"></i>
                    </span>
                  </div>

                  {/* Become a partner */}
                  <div className="PartnersLocator__filter PartnersLocator__filter--desktop">
                    <h4 className="PartnersLocator__becomePartnerTitle">
                      Apply to become a{' '}
                      {partnersListingNameTypes &&
                      partnersListingNameTypes.length >= 2 &&
                      partnersListingNameTypes[1].value
                        ? partnersListingNameTypes[1].value
                        : 'Technology Partner'}
                    </h4>
                    <p className="PartnersLocator__becomePartnerDesc">
                      Join forces with UiPath to fast-track portfolio innovation, expand your
                      capabilities and accelerate demand.
                    </p>
                    <a
                      className="PartnersLocator__becomePartnerCTA Button Button--secondary"
                      href={becomeAPartnerObj[1]?.value}
                      rel=" noopener">
                      {becomeAPartnerObj[0]?.value}
                      <WrapperImage
                        src={btnPrimaryIcon}
                        alt="arrow"
                        width={24}
                        height={24}
                        threshold={650}
                      />
                    </a>
                  </div>
                  <div className="PartnersLocator__filter PartnersLocator__filter--desktop">
                    <h4 className="PartnersLocator__becomePartnerTitle">
                      Access pre-built integrations
                    </h4>
                    <p className="PartnersLocator__becomePartnerDesc">
                      Download pre-built integrations and other reusable components on the UiPath
                      Marketplace.
                    </p>
                    <a
                      className="PartnersLocator__becomePartnerCTA PartnersLocator__becomePartnerCTA--link"
                      href="https://marketplace.uipath.com/"
                      target="_blank"
                      rel=" noopener">
                      Go to the UiPath Marketplace
                      <WrapperImage src={arrowLongRight} width={24} height={24} threshold={650} />
                    </a>
                  </div>
                </div>
              </styles.PartnersLocatorFilters>
            </div>
          </Container>
          {/* Become a partner */}
          <div className="PartnersLocator__filter PartnersLocator__filter--mobile">
            <h4 className="PartnersLocator__becomePartnerTitle">
              Apply to become a{' '}
              {partnersListingNameTypes &&
              partnersListingNameTypes.length >= 2 &&
              partnersListingNameTypes[1].value
                ? partnersListingNameTypes[1].value
                : 'Technology Partner'}
            </h4>
            <p className="PartnersLocator__becomePartnerDesc">
              Join forces with UiPath to fast-track portfolio innovation, expand your capabilities
              and accelerate demand.
            </p>
            <a
              className="PartnersLocator__becomePartnerCTA Button Button--secondary"
              href={becomeAPartnerObj[1]?.value}
              rel=" noopener">
              {becomeAPartnerObj[0]?.value}
              <WrapperImage src={partnerBlank} alt="arrow" width={24} height={24} threshold={650} />
            </a>
          </div>
          <div className="PartnersLocator__filter PartnersLocator__filter--mobile">
            <h4 className="PartnersLocator__becomePartnerTitle">Access pre-built integrations</h4>
            <p className="PartnersLocator__becomePartnerDesc">
              Download pre-built integrations and other reusable components on the UiPath
              Marketplace.
            </p>
            <a
              className="PartnersLocator__becomePartnerCTA PartnersLocator__becomePartnerCTA--link"
              href="https://connect.uipath.com/"
              target="_blank"
              rel=" noopener">
              Go to the UiPath Marketplace
              <WrapperImage src={arrowLongRight} width={24} height={24} threshold={650} />
            </a>
          </div>
        </styles.Wrapper>

        <PartnersModal onClose={handleClose} open={open} data={selectedPartner} />
        <GoTop />
      </div>
    </Layout.Template>
  )
}

export default TechnologyPartners
